import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";

export interface PortalTablePaginationProps {
	count: number;
	page: number;
	rowsPerPage: number;
	rowsPerPageOptions?: number[];
	onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
	onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export interface PortalTableLayoutProps {
	toolbar?: React.ReactNode;
	pagination?: PortalTablePaginationProps;
	children: React.ReactNode;
	fillHeight?: boolean;
}

export default function PortalTableLayout({ toolbar, pagination, children, fillHeight = true }: PortalTableLayoutProps) {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0, width: "100%", ...(fillHeight && { flex: 1, minHeight: 0 }) }}>
			{toolbar}
			<Paper
				elevation={0}
				sx={{
					display: "flex",
					flexDirection: "column",
					overflow: "hidden",
					minWidth: 0,
					width: "100%",
					border: "1px solid",
					borderColor: "divider",
					...(fillHeight && { flex: 1, minHeight: 0 }),
				}}>
				<TableContainer
					sx={{
						width: "100%",
						minWidth: 0,
						overflowX: "auto",
						...(fillHeight && { flex: 1, minHeight: 0, overflowY: "auto" }),
					}}>
					{children}
				</TableContainer>
				{pagination && (
					<TablePagination
						component="div"
						count={pagination.count}
						page={pagination.page}
						rowsPerPage={pagination.rowsPerPage}
						rowsPerPageOptions={pagination.rowsPerPageOptions ?? [5, 10, 25, 50]}
						onPageChange={pagination.onPageChange}
						onRowsPerPageChange={pagination.onRowsPerPageChange}
					/>
				)}
			</Paper>
		</Box>
	);
}
